import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static closeDelay = 240

  connect() {
    this.updateOpenPanelHeight = this.updateOpenPanelHeight.bind(this)
    this.element.addEventListener("turbo:frame-load", this.updateOpenPanelHeight)
    window.addEventListener("resize", this.updateOpenPanelHeight)
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.updateOpenPanelHeight)
    window.removeEventListener("resize", this.updateOpenPanelHeight)
  }

  toggle(event) {
    const button = event.currentTarget
    const row = document.getElementById(event.params.rowId)
    const frame = document.getElementById(event.params.frameId)
    const parentRow = document.getElementById(event.params.parentId)
    if (!row || !frame) return

    const opening = !row.classList.contains("is-open")
    this.closeOpenRows(row)

    if (opening) {
      this.openRow(row)
      if (parentRow) parentRow.classList.add("is-review-open")
      button.textContent = "Close"

      if (!frame.dataset.loaded) {
        frame.src = event.params.url
        frame.dataset.loaded = "true"
      }
    } else {
      this.closeRow(row)
      if (parentRow) parentRow.classList.remove("is-review-open")
      button.textContent = "Review"
    }
  }

  openRow(row) {
    clearTimeout(row.closeTimer)
    row.classList.remove("d-none")
    const panel = this.panelFor(row)
    if (panel) panel.style.maxHeight = "0px"

    requestAnimationFrame(() => {
      row.classList.add("is-open")
      this.setPanelHeight(row)
    })
  }

  closeRow(row) {
    this.setPanelHeight(row)

    requestAnimationFrame(() => {
      const panel = this.panelFor(row)
      if (panel) panel.style.maxHeight = "0px"
    })

    row.classList.remove("is-open")
    clearTimeout(row.closeTimer)

    row.closeTimer = setTimeout(() => {
      row.classList.add("d-none")
    }, this.constructor.closeDelay)
  }

  closeOpenRows(currentRow) {
    this.element.querySelectorAll(".smartabase-match-review-row.is-open").forEach((row) => {
      if (row === currentRow) return

      this.closeRow(row)
      const button = this.element.querySelector(`[data-smartabase-review-row-row-id-param="${row.id}"]`)
      const parentRow = button ? document.getElementById(button.dataset.smartabaseReviewRowParentIdParam) : null
      if (parentRow) parentRow.classList.remove("is-review-open")
      if (button) button.textContent = "Review"
    })
  }

  updateOpenPanelHeight() {
    this.element.querySelectorAll(".smartabase-match-review-row.is-open").forEach((row) => {
      this.setPanelHeight(row)
    })
  }

  setPanelHeight(row) {
    const panel = this.panelFor(row)
    if (!panel) return

    panel.style.maxHeight = `${panel.scrollHeight}px`
  }

  panelFor(row) {
    return row.querySelector(".smartabase-match-review-panel")
  }
}
